export const setMockData =
  <T>(key: string) =>
  (data: T) =>
    localStorage.setItem(key, JSON.stringify(data));
